:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

img {
  width: 78px;
  min-width: 78px;
}
@media (min-width: 768px) {
  img {
    width: 113px;
    min-width: 113px;
  }
}

a {
  text-decoration: none;
}
a:focus {
  outline: 2px solid #009cc2;
}